import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// Dropdown of roll serials RECEIVED at a studio with balance > 0, for a product category.
export const SerialSelect = ({ studioId, category, value, onChange, testid }) => {
  const [serials, setSerials] = useState([]);

  useEffect(() => {
    if (!studioId || !category) return;
    api
      .get(`/roll-serials?status=received&has_balance=true&studio_id=${studioId}&category=${category}`)
      .then(({ data }) => setSerials(data || []))
      .catch(() => setSerials([]));
  }, [studioId, category]);

  return (
    <div>
      <Select value={value || ""} onValueChange={(v) => onChange(v === "__none" ? "" : v)}>
        <SelectTrigger className="min-h-[40px]" data-testid={testid || "serial-select"}>
          <SelectValue placeholder={serials.length ? "Select roll serial" : "No rolls in stock"} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__none">No serial</SelectItem>
          {serials.map((s) => (
            <SelectItem key={s.id} value={s.id} data-testid={`serial-opt-${s.serial}`}>
              {s.serial}{s.is_partial ? " · Partial" : ""} — {Math.round(s.balance_sqft)} sqft remaining
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {studioId && category && !serials.length && (
        <p className="mt-1 text-xs text-amber-700" data-testid="serial-select-empty-hint">
          No {category} roll serials received at this studio yet — ask HQ to dispatch rolls or add
          them via Stock → Opening stock.
        </p>
      )}
    </div>
  );
};
